import React, { useEffect, useState } from 'react';
import { Host } from '@wix/sdk';

import { ControlService } from '../../globalDesignPanel/types';
import { loadControlService } from './index';

interface IControlsServiceContext {
  service: ControlService;
}

export interface ControlsServiceProviderProps {
  host: Host;
  children?: React.ReactNode;
}

export const ControlsServiceContext =
  React.createContext<IControlsServiceContext>({} as IControlsServiceContext);

export const ControlsServiceProvider: React.FC<{
  host: Host;
  children?: React.ReactNode;
}> = ({ host, children }) => {
  const [service, setService] = useState<ControlService | undefined>(undefined);

  useEffect(() => {
    loadControlService({ host }).then((s) => {
      setService(s);
    });
  }, []);

  if (!service) {
    return null;
  }

  return (
    <ControlsServiceContext.Provider value={{ service }}>
      {children}
    </ControlsServiceContext.Provider>
  );
};
